// extracted by mini-css-extract-plugin
module.exports = {"select-container":"Select_select-container__rpLup","input-blue":"Select_input-blue__OzmaY","input-red":"Select_input-red__q0w1K"};